/* eslint-disable guard-for-in */
/*eslint max-len: 0*/
const {
    isUfeEnvQA,
    isUfeEnvLocal
} = require('utils/Env');
const {
    OPEN_SPA_PAGE,
    OPEN_SPA_PAGE_API_LOADED,
    OPEN_SPA_PAGE_DOM_UPDATED,
    OPEN_SPA_PAGE_IMAGES_PRELOADING
} = require('../../constants/performace/marks');


const Perf = Sephora.isNodeRender ? {} : Sephora.Util.Perf;

function normalizeTime(time) {
    return Math.round(time * 1000) / 1000;
}

Perf.getLogs = function (outputAsTable = false) {
    if (outputAsTable) {
        let table = Perf.loadEvents
            .map(event => {
                let output = {
                    time: normalizeTime(event.time)
                };
                output.data = Array.isArray(event.data) ? event.data[0] : event.data;
                return output;
            });

        console.table(table);
    } else {
        for (var i = 0, max = Perf.loadEvents.length; i < max; i++) {
            let event = Perf.loadEvents[i];
            let time = normalizeTime(event.time);
            let prefix = time + ':';

            if (typeof event.data === 'string') {
                console.log(prefix + ' ' + event.data);
            } else if (Array.isArray(event.data)) {
                // Support for reports with multiple console arguments
                let logData = event.data.slice();
                logData.unshift(prefix);
                console.log.apply(console, logData);
            }
        }
    }
};

Perf.getSummary = function () {
    let summary = {};
    Perf.loadEvents
        .filter(event => event.timestamp)
        .forEach(event => summary[event.label] = normalizeTime(event.time));

    console.table(summary);
};

Perf.getMeasurements = function () {
    let eventMap = {};
    let measurements = {};

    // Group load events by event type
    Perf.loadEvents
        .filter(event => event.timestamp)
        .forEach(event => {
            let eventPrefix = event.data.split(' ')[0];

            if (!eventMap[eventPrefix]) {
                eventMap[eventPrefix] = [event.data];
            } else {
                eventMap[eventPrefix].push(event.data);
                eventMap[eventPrefix].sort((a, b) => a.time - b.time);
            }
        });

    // Set measurement between first and last recorded events of every event type
    Object.keys(eventMap).forEach(event => {
        let events = eventMap[event];
        let eventsLength = events.length;

        /*jshint ignore:start*/
        function addEntry(...entries) {
            entries.forEach(item => {
                let entry;
                let {
                    name,
                    ...data
                } = item;

                window.performance.clearMeasures(name);
                window.performance.measure(name, item.eventStart, item.eventEnd);
                entry = window.performance.getEntriesByName(name);
                measurements[name] = {
                    ...data,
                    duration: entry.length ? normalizeTime(entry[0].duration) : null
                };
            });
        }
        /*jshint ignore:end*/

        if (eventsLength < 2) {
            // We cannot measure deltas with only one event
            return;
        }

        switch (event) {
            case OPEN_SPA_PAGE: {
                addEntry({
                    name: event,
                    eventStart: events[0],
                    eventEnd: events[events.length - 1]
                }, {
                    name: `${event} (API loaded)`,
                    eventStart: events[0],
                    eventEnd: events[events.findIndex(pageEvent => pageEvent === OPEN_SPA_PAGE_API_LOADED)]
                }, {
                    name: `${event} (image preload triggered)`,
                    eventStart: events[events.findIndex(pageEvent => pageEvent === OPEN_SPA_PAGE_API_LOADED)],
                    eventEnd: events[events.findIndex(pageEvent => pageEvent === OPEN_SPA_PAGE_IMAGES_PRELOADING)]
                }, {
                    name: `${event} (DOM updated)`,
                    eventStart: events[events.findIndex(pageEvent => pageEvent === OPEN_SPA_PAGE_IMAGES_PRELOADING)],
                    eventEnd: events[events.findIndex(pageEvent => pageEvent === OPEN_SPA_PAGE_DOM_UPDATED)]
                });

                break;
            }
            default: {
                if (eventsLength === 4) {
                    // Service entries have 3 different deltas we want to measure
                    addEntry({
                        name: `${event}_loading`,
                        eventStart: events[0],
                        eventEnd: events[1]
                    }, {
                        name: `${event}_rendering`,
                        eventStart: events[2],
                        eventEnd: events[3]
                    }, {
                        name: `${event}_total`,
                        eventStart: events[0],
                        eventEnd: events[3]
                    });
                } else {
                    // For all others we measure delta between first and last associated events
                    addEntry({
                        name: event,
                        eventStart: events[0],
                        eventEnd: events[eventsLength - 1]
                    });
                }

                break;
            }
        }
    });

    if (typeof console.table === 'function') {
        console.table(measurements);
    }
};

Perf.getEntrySize = function (filepath) {
    const perfEntries = performance.getEntries();
    let transferSize = 0;
    for (let i = 0; i < perfEntries.length; i++) {
        let entry = perfEntries[i];
        if ('transferSize' in entry) {
            if (entry.name.indexOf(filepath) > -1) {
                transferSize = entry.transferSize;
            }
        }
    }
    console.log(`Transfer size of ${filepath}: ${transferSize}`);
    return transferSize;
};

if ((isUfeEnvQA || isUfeEnvLocal) && !Sephora.isNodeRender) {

    let InflatorComps = Sephora.Util.InflatorComps;
    Perf.logRenderPerf = function () {

        let compArr = {};

        for (var compName in InflatorComps.Comps) {
            let comp = InflatorComps.Comps[compName];
            if (comp.renderCount) {
                compArr[compName] = {
                    renderCount: comp.renderCount,
                    renderTime: comp.renderTime,
                    inclusiveRenderTime: comp.inclusiveRenderTime,
                    rootRenderTime: comp.rootRenderTime || 0
                };
            }
        }

        console.log('------------------');
        console.log('Total Render Function Time: ' + Sephora.Util.InflatorComps.totalRenderTime + ' ms');
        console.log('------------------');
        console.log('------------------');
        console.log('Total Render Function Time On Page Render: ' + Sephora.Util.InflatorComps.totalReactTimeOnPageRender + ' ms');
        console.log('------------------');
        console.log('------------------');
        console.log('Total rootRenderTime Time: ' + Sephora.Util.InflatorComps.rootRenderTime + ' ms');
        console.log('------------------');
        if (console.table) {
            console.table(compArr);
        }

        // compArr.sort(function(a, b) {
        //     return (b.inclusiveRenderTime || 0) - (a.inclusiveRenderTime || 0);
        // });
        // for (i = 0; i < 20; i++) {
        //     let comp = compArr[i],
        //         compClass = comp().prototype.class,
        //         count = i+1;
        //     if (comp.renderTime || comp.inclusiveRenderTime) {
        //         console.log(count + ': ' + compClass + ' Render Count: ' + comp.renderCount);
        //         console.log(count + ': ' + compClass + ' Render Function Time: ' + comp.renderTime + 'ms');
        //         console.log(count + ': ' + compClass + ' inclusiveRenderTime Time: ' + comp.inclusiveRenderTime + 'ms');
        //         comp.rootRenderTime && console.log(count + ': ' + compClass + ' rootRenderTime Time: ' + comp.rootRenderTime + 'ms');
        //     }
        // }
        // compArr.sort(function(a, b) {
        //     return (a.rootRenderTime || 0) - (b.rootRenderTime || 0);
        // });
        // for (i = compArr.length-1; i >= 0; i--) {
        //     let comp = compArr[i],
        //         compClass = comp().prototype.class;
        //     if (comp.rootRenderTime) {
        //         console.log(compClass + ' rootRenderTime Time: ' + comp.rootRenderTime + 'ms');
        //     }
        // }

        // console.log('Total inclusiveRenderTime Time: ' + Sephora.Util.InflatorComps.totalInclusiveRenderTime + 'ms');
    };

    Perf.resetRenderPerf = function () {
        for (var compName in InflatorComps.Comps) {
            let comp = InflatorComps.Comps[compName];
            if (comp.renderCount) {
                comp.renderCount = 0;
                comp.renderTime = 0;
                comp.inclusiveRenderTime = 0;
            }
        }
        Sephora.Util.InflatorComps.totalRenderTime = 0;
    };
}

module.exports = Perf;
